import React, { useState, useEffect, useRef } from 'react';

export function PurchaseConfirmationSheet({
                                              isVisible,
                                              onConfirm,
                                              onCancel,
                                              period,
                                              devices,
                                              totalPrice,
                                              currentBalance,
                                              newBalance
                                          }) {
    const [countdown, setCountdown] = useState(3);
    const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);
    const sheetRef = useRef(null);
    const timerRef = useRef(null);

    // Блокируем прокрутку body при открытии шторки
    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    useEffect(() => {
        if (isVisible) {
            setCountdown(3);
            setIsConfirmEnabled(false);

            timerRef.current = setInterval(() => {
                setCountdown((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        setIsConfirmEnabled(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [isVisible]);

    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);

            if (sheetRef.current) {
                const maxTranslate = window.innerHeight * 0.5;
                const translateY = Math.min(diff, maxTranslate);
                sheetRef.current.style.transform = `translateY(${translateY}px)`;
            }
        }
    };

    const handleTouchEnd = () => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            onCancel();
        }

        if (sheetRef.current) {
            sheetRef.current.style.transform = '';
        }

        setStartY(null);
        setCurrentY(null);
    };

    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);

                if (sheetRef.current) {
                    const maxTranslate = window.innerHeight * 0.5;
                    const translateY = Math.min(diff, maxTranslate);
                    sheetRef.current.style.transform = `translateY(${translateY}px)`;
                }
            }
        };

        const handleMouseUp = () => {
            const diff = currentY || 0;

            if (diff > 100) {
                onCancel();
            }

            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleConfirm = () => {
            onConfirm();
    };

    const handleCancel = () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }
        onCancel();
    };

    // Форматирование периода
    const getPeriodText = () => {
        if (period === 1) return 'месяц';
        if (period >= 2 && period <= 4) return 'месяца';
        return 'месяцев';
    };

    // Форматирование устройств
    const getDevicesText = () => {
        if (devices === 1) return 'устройство';
        if (devices >= 2 && devices <= 4) return 'устройства';
        return 'устройств';
    };

    return (
        <div className={`confirmation-sheet-wrapper ${isVisible ? 'visible' : ''}`}>
            <div
                className="sheet-overlay"
                onClick={handleCancel}
            />

            <div
                ref={sheetRef}
                className="confirmation-sheet"
            >
                <div className="sheet-content" style={{
                    paddingBottom: '20px'
                }}>
                    <div
                        className="sheet-drag-handle"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div className="drag-indicator" />
                    </div>

                    <h3 className="sheet-title">
                        Подтверждение покупки
                    </h3>

                    {/* Детали покупки под заголовком */}
                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px' }}>
                            {devices} {getDevicesText()} на {period} {getPeriodText()}
                        </p>
                    </div>

                    {/* Объединенный блок суммы и остаточного баланса */}
                    <div className="custom-content-box" style={{
                        background: 'linear-gradient(40deg, rgba(64, 82, 73, 0.3) 50%, #2a5a3a 100%)',
                        borderRadius: '16px',
                        padding: '16px 16px',
                        marginBottom: '20px',
                        border: 'none'
                    }}>
                        <div style={{ marginBottom: '12px' }}>
                            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', textAlign: 'center', marginBottom: '4px' }}>
                                Сумма покупки
                            </p>
                            <p style={{ color: '#ffffff', fontSize: '32px', fontWeight: '700', textAlign: 'center' }}>
                                {totalPrice} ₽
                            </p>
                        </div>

                        <div style={{
                            borderTop: '1px solid rgba(255,255,255,0.1)',
                            paddingTop: '12px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px' }}>Баланс после покупки</span>
                            <span style={{ color: '#ffffff', fontSize: '18px', fontWeight: '600' }}>{newBalance} ₽</span>
                        </div>
                    </div>

                    {/* Кнопки - подняты выше, убраны лишние отступы */}
                    <div className="sheet-buttons" style={{ marginTop: '8px'}}>
                        <button
                            className="sheet-button sheet-button-cancel"
                            onClick={handleCancel}
                        >
                            Отменить
                        </button>
                        <button
                            className={`sheet-button btn-green`}
                            onClick={handleConfirm}
                        >
                            Купить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}